import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import AutosSearch from 'components/AutosSearch';
import BottomSheet from 'components/BottomSheet';
import { Desktop, Mobile } from 'components/Responsive';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

import { Container } from './styles';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  show: boolean;
  onClose: () => void;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const AutosSearchEdit = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  show,
  onClose,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const {
    traveler,
    pickUpPoint,
    dropOffPoint,
    pickUpDate,
    dropOffDate,
    pickUpTime,
    dropOffTime,
    diffDropOff,
    branchCompany,
  } = useSelector((state: RootState) => state.autos);

  const search = () => (
    <AutosSearch
      defaultTraveler={traveler}
      defaultPickUpPoint={pickUpPoint}
      defaultDropOffPoint={dropOffPoint}
      defaultPickUpDate={pickUpDate ? new Date(pickUpDate) : undefined}
      defaultDropOffDate={dropOffDate ? new Date(dropOffDate) : undefined}
      defaultPickUpTime={pickUpTime}
      defaultDropOffTime={dropOffTime}
      defaultDiffDropOff={diffDropOff}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      isHome={false}
      onClose={onClose}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
    />
  );

  return (
    <>
      <Mobile>
        <BottomSheet show={show} onClose={onClose} noHeader zIndex={2}>
          {search()}
        </BottomSheet>
      </Mobile>
      <Desktop>
        <ApplicationOverlayContent show={show} onClose={onClose}>
          <Container>{search()}</Container>
        </ApplicationOverlayContent>
      </Desktop>
    </>
  );
};
export default AutosSearchEdit;
